import { useTheme } from '../lib/theme';

const THEMES = [
  // { id: 'pleasant-light', icon: '☀️', label: 'Daylight', title: 'Pleasant Daylight (Soft Pearl & Ocean Navy)' },
  { id: 'pleasant-midnight', icon: '🌙', label: 'Midnight', title: 'Pleasant Midnight (Eye-Comfort Slate & Indigo)' },
  { id: 'pleasant-ocean', icon: '🌊', label: 'Ocean', title: 'Pleasant Ocean (Police Sapphire & Cyan)' },
];

/** Pleasant color-scheme switcher shown in every page header. */
export default function ThemeSwitcher({ className = '', labelClass = null }) {
  const [theme, setTheme] = useTheme();
  return (
    <div className={`theme-switcher ${className}`.trim()} title="Select Pleasant Color Scheme">
      {THEMES.map((t) => (
        <button
          key={t.id}
          onClick={() => setTheme(t.id)}
          className={`theme-btn${theme === t.id ? ' active-theme' : ''}`}
          data-set-theme={t.id}
          title={t.title}
        >
          <span>{t.icon}</span>
          {labelClass && <> <span className={labelClass}>{t.label}</span></>}
        </button>
      ))}
    </div>
  );
}
